<template>
  <v-menu v-model="mostrar" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </template>
    <v-card
      width="450px">
      <v-card-title>Filtros</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <custom-select
            v-model="filtros.tipos"
            label="Tipo"
            item-value="id"
            item-text="textoTipo"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeLicitacion">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.normatividad"
            label="Normatividad"
            item-value="id"
            item-text="textoNormatividad"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeNormatividad">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.caracter"
            label="Carácter"
            item-value="id"
            item-text="textoCaracter"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeCaracter">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.estatus"
            label="Estatus"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="estatusDeLicitacion">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
// import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'FiltrosLicitaciones',
  components: {
    // CustomAutoComplete,
    CustomSelect,
  },
  props: {
    licitaciones: {
      type: Array,
      required: false,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
      tiposLicitacion: [
        { id: 1, texto: 'LICITACIÓN PÚBLICA' },
        { id: 2, texto: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
      ],
      tiposCaracter: [
        { id: 1, texto: 'NACIONAL' },
      ],
      tiposNormatividad: [
        { id: 1, texto: 'FEDERAL' },
        { id: 2, texto: 'ESTATAL' },
      ],
    };
  },
  methods: {
    getTextoTipo(tipo) {
      return this.tiposLicitacion.find((tipoLicitacion) => tipo === tipoLicitacion.id);
    },
    getTextoNormatividad(normatividad) {
      return this.tiposNormatividad
        .find((tipoNormatividad) => normatividad === tipoNormatividad.id);
    },
    getTextoCaracter(caracter) {
      return this.tiposCaracter
        .find((tipoCaracter) => caracter === tipoCaracter.id);
    },
  },
  computed: {
    tiposDeLicitacion() {
      const tiposDeLicitacion = this.licitaciones.map((licitacion) => ({
        id: licitacion.tipo,
        textoTipo: this.getTextoTipo(licitacion.tipo).texto,
      }));
      if (tiposDeLicitacion.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(tiposDeLicitacion, 'id')
        .sort((a, b) => (`${a.textoTipo}`).localeCompare(b.textoTipo));
    },
    tiposDeNormatividad() {
      const tiposDeNormatividad = this.licitaciones.map((licitacion) => ({
        id: licitacion.normatividad,
        textoNormatividad: this.getTextoNormatividad(licitacion.normatividad).texto,
      }));
      if (tiposDeNormatividad.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(tiposDeNormatividad, 'id')
        .sort((a, b) => (`${a.textoNormatividad}`).localeCompare(b.textoNormatividad));
    },
    tiposDeCaracter() {
      const tiposDeCaracter = this.licitaciones.map((licitacion) => ({
        id: licitacion.caracter,
        textoCaracter: this.getTextoCaracter(licitacion.caracter).texto,
      }));
      if (tiposDeCaracter.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(tiposDeCaracter, 'id')
        .sort((a, b) => (`${a.textoCaracter}`).localeCompare(b.textoCaracter));
    },
    estatusDeLicitacion() {
      const estatusDeLicitacion = this.licitaciones.map((licitacion) => licitacion.estatus);
      if (estatusDeLicitacion.length <= 0) return [];
      return estatusDeLicitacion
        .sort((a, b) => (`${a.textoNormatividad}`).localeCompare(b.textoNormatividad));
    },
  },
};
</script>

<style lang="scss">
</style>
